import { render, staticRenderFns } from "./posit.vue?vue&type=template&id=39438ec0&scoped=true"
import script from "./posit.vue?vue&type=script&lang=js"
export * from "./posit.vue?vue&type=script&lang=js"
import style0 from "./posit.vue?vue&type=style&index=0&id=39438ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39438ec0",
  null
  
)

export default component.exports